import { useEffect, useState } from 'react';

/**
 * Custom hook that returns the current time and updates every second
 * @returns Current time as Date object
 */
export const useCurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update time every second
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  return currentTime;
};

/**
 * Format time to 12-hour format with AM/PM
 * @param date - Date object to format
 * @returns Formatted time string (e.g., "08:52 AM")
 */
export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};
